export { LocalStorageService, SessionStorageService, StorageService } from './services';


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/index.ts